'use client'

import { cx } from 'utils/cx'

import { ListBody } from '../ListItemBody'

import styles from '../ListItem.module.scss'

type ButtonListItemProps = {
	readonly id?: string
	readonly title: string
	readonly icon?: JSX.Element
	readonly selected?: boolean
	readonly 'data-testid'?: string
	readonly subtitle?: JSX.Element
	readonly onClick?: (event: React.MouseEvent) => void
	readonly 'aria-current'?: boolean
	readonly titleUpperCase?: boolean
	readonly showArrow?: boolean
}

export function ButtonListItem(props: ButtonListItemProps) {
	const {
		id,
		title,
		icon,
		selected,
		'data-testid': dataTestId,
		subtitle,
		onClick = () => {},
		'aria-current': ariaCurrent = 'page',
		titleUpperCase = false,
		showArrow = true,
	} = props

	return (
		<li id={id} data-testid={dataTestId}>
			<button
				className={cx(
					styles.listItem,
					styles.buttonListItem,
					selected && styles.selected
				)}
				onClick={
					selected ? (e: React.MouseEvent) => e.preventDefault() : onClick
				}
				aria-current={selected && ariaCurrent}
				aria-disabled={selected}
			>
				<ListBody
					title={title}
					icon={icon}
					subtitle={subtitle}
					titleUpperCase={titleUpperCase}
					showArrow={showArrow}
				/>
			</button>
		</li>
	)
}
